import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  InputAdornment,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

//https://glowagain-presignups-worker.glowagainapp.workers.dev

const EarlyAccessPage = () => {
  const [signupCount, setSignupCount] = useState(2290);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    let count = 2290;
    const target = 2317;
    const interval = setInterval(() => {
      count += 1;
      setSignupCount(count);
      if (count >= target) clearInterval(interval);
    }, 60);
    return () => clearInterval(interval);
  }, []);

  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const res = await fetch(
        "https://glowagain-presignups-worker.glowagainapp.workers.dev/api/presignup",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );
      console.log("res", res);
      if (res.ok) {
        setStatus("success");
        setEmail("");
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Error submitting email:", error);

      setStatus("error");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#F5F5F5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 2,
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          textAlign: "center",
          bgcolor: "white",
          p: { xs: 3, sm: 5 },
          borderRadius: 4,
          boxShadow: 3,
          width: "100%",
        }}
      >
        <Typography variant={isMobile ? "h5" : "h4"} fontWeight="bold" mb={1}>
          GlowAgain: The Dating Readiness App
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" mb={3}>
          From Self-Discovery to Dating Success
        </Typography>

        <Box sx={{ textAlign: "left", mb: 3 }}>
          <Typography>✅ 45-day structured dating prep program</Typography>
          <Typography>
            ✅ AI-powered pattern recognition & readiness scoring
          </Typography>
          <Typography>
            ✅ Confidence-building and intentional dating tools
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="outlined"
            placeholder="Enter your email to get early access"
            required
            sx={{ mb: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <FavoriteBorderIcon sx={{ color: "#FF6F61" }} />
                </InputAdornment>
              ),
            }}
          />

          <Button
            type="submit"
            variant="contained"
            fullWidth
            size="large"
            sx={{
              background: "linear-gradient(90deg, #FF6F61 0%, #FFC371 100%)",
              ":hover": { opacity: 0.9 },
              mb: 2,
              fontWeight: 600,
            }}
          >
            Join the Waitlist
          </Button>

          {status === "success" && (
            <Typography color="success.main">
              You're on the waitlist 🎉
            </Typography>
          )}
          {status === "error" && (
            <Typography color="error">
              Something went wrong. Try again.
            </Typography>
          )}
        </form>

        <Typography variant="body2" color="text.secondary">
          🚀 {signupCount.toLocaleString()} early signups in the last 48 hours
        </Typography>
      </Container>
    </Box>
  );
};

export default EarlyAccessPage;
